import { ICON_CHECK, ICON_TRASH } from "../../utils/useIcons";
import "./FieldStyle.css";
import React from "react";
import { ContextLanguage } from "../../context/Context.Language";

const FieldTextState = ({
  value = "",
  setValue = () => {},
  label = "Label",
  className = "",
  icon,
  onKeyPress = () => {},
  name,
}) => {
  const [focus, setFocus] = React.useState(false);
  const { langugate } = React.useContext(ContextLanguage);
  return (
    <div className="flex ">
      <div className="input-container ">
        <input
          id={name}
          onFocus={() => setFocus(true)}
          onBlur={() => setFocus(false)}
          onKeyPress={onKeyPress}
          type={"text"}
          className={className}
          value={value}
          onChange={(e) => {
            setValue(e.target.value);
          }}
        />
        <label className={value !== undefined && value !== "" && "filled"}>
          <div className="flex gap-3">
            {!focus && value?.length === 0 && (
              <div
                className={`w-4 my-auto ${
                  focus ? "text-[#3ab4ed]" : " text-laundry-gray-50 "
                }`}
              >
                {icon}
              </div>
            )}
            <div
              className={`my-auto  ${
                langugate === "TH" ? " text-base-th " : " text-base "
              } ${focus ? "text-[#3ab4ed]" : " text-laundry-gray-50 "}`}
            >
              {label}
            </div>
          </div>
        </label>
      </div>
    </div>
  );
};

export default FieldTextState;
